import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from 'src/app/shared/models/listing.model';
import { Languages, Service, ServiceStatus } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { ReportsService } from 'src/app/shared/services/reports.service';
import { Router, NavigationExtras } from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/front-user/shared/models/user.model';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';

import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { MyRequestsService } from 'src/app/shared/services/my-Requests.service';
import { MyTasksService } from 'src/app/shared/services/my-Tasks.service';
import { CrewChangeService } from 'src/app/shared/services/crewChange.service';

@Component({
  selector: 'app-CrewChange-report',
  templateUrl: './CrewChange-report.component.html',
  styleUrls: ['./CrewChange-report.component.css']
})
export class CrewChangeReportComponent implements OnInit {
  showAutoCompleteMinLengthMessage: Boolean;
  private collection: Listing;
  private itemsMenu: MenuItem[] = [];
  lang: string;
  pageSize = 15;
  userName: string = "";
  requestNumber: string = "";
  isAdmin: Boolean
  creationDateFrom: string = "";
  creationDateTo: string = "";
  dateFromFormatted: string = "";
  dateToFormatted: string = "";
  transitDateFormatted: string = "";
  serviceId: string = "29";
  directionId: string = "";
  serviceStatus: string = "";
  transitDate: string = "";
  unitName: string = "";
  isCompleted: boolean = null;


  exportngParametersUrl: string = "";
  public currentUser: User = new User();
  InvalidDateMessage: string;
  hideExportButton: Boolean
  isAutoCompleteLoading: Boolean
  agentsNamesList = [];
  public sailDirections: SailDirection[] = [];
  //public servicesList = [];
  public statusesList: [] = [];
  agentNameNotFoundMessage: string;
  autoCompleteMinQueryLength: number = 3;
  AgentsNamesTextBoxPlaceHolder: string;
  showFromDateGreaterThanTodayDateMessage: Boolean
  showFromDateGreaterThanToDateMessage: Boolean
  responseObj: ResponseObject;
  isErrorMessage: Boolean = false;
  @ViewChild('CrewChangeReport',{static: false}) gridView: GridViewComponent;
  HasMenu: boolean = true;
  HasTransit: boolean = false;
  //#endregion
  IsHtml: boolean = true;
  Service = Service;
  transitRequestId: string;
  feesRequestId: string;
  serviceStatusLookup = ServiceStatus;
  constructor(private baseRequestSrv: BaseRequestService,
    private myRequestsService: MyRequestsService,
    private crewChangeService: CrewChangeService,
    private myReportsService: ReportsService,
    private lookupService: LookupService,
    private global: GlobalServices,
    private agentService: AgentService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private localeService: BsLocaleService,
    public datepipe: DatePipe,
    private myTasksService: MyTasksService) {
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
  }


  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;


  async ngOnInit() {
    this.InvalidDateMessage = await this.translate.get('SHARED.InvalidDate').toPromise();
    this.AgentsNamesTextBoxPlaceHolder = await this.translate.get('SHARED.REPORTS.AGENT_NAME_MIN_CHARS').toPromise();

    this.currentUser = this.authenticationService.currentUserValue;
    enGbLocale.invalidDate = this.InvalidDateMessage;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');

    if (this.currentUser.IsAdmin) {
      this.isAdmin = true;
    }
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    this.loadLookups();
    this.loadSailDirections();
    this.loadSearchCriteria();
    this.loadReport();
    this.agentNameNotFoundMessage = this.translate.instant('SHARED.NoItems');
  }


  loadAgentsDisplayNames(keyWord: string) {
    this.isAutoCompleteLoading = true;
    this.agentService.GetAgentsInfoByDisplayName(keyWord).subscribe(s => {
      this.agentsNamesList = s.Data;
      this.isAutoCompleteLoading = false;
    });
  }
  getCrewChangeReportData() {

    this.removeAllValidationMessages()


    if (this.isFromDateGreaterThanToDate()) {
      this.showFromDateGreaterThanToDateMessage = true;
      return;
    }

    this.loadReport();

  }

  loadReport() {
    this.storeSearchCriteria();
    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;
    this.transitDate = this.transitDate == null ? "" : this.transitDate;
    if (this.creationDateFrom.toString() != this.InvalidDateMessage && this.creationDateTo.toString() != this.InvalidDateMessage) {
      this.global.isLoaderEnabled = true;
      this.dateFromFormatted = this.creationDateFrom == "" ? "" : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      this.dateToFormatted = this.creationDateTo == "" ? "" : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
      this.transitDateFormatted = this.transitDate == "" ? "" : this.datepipe.transform(this.transitDate, 'MM/dd/yyyy');

      this.createExportingParametersUrl();
      this.myReportsService.getCrewChangeReport(0, this.pageSize, null, null, this.currentUser.UserId, encodeURIComponent(this.userName), this.requestNumber, this.dateFromFormatted, this.dateToFormatted, this.serviceId, this.serviceStatus, this.directionId, this.transitDateFormatted, this.isCompleted, encodeURIComponent(this.unitName)).subscribe(
        s => {
          this.responseObj = s;
          if (!this.responseObj.Success) {
            this.isErrorMessage = true;
          }
          else {
            this.collection = s.Data;
            this.hideExportButton = s.Data.TotalNumber > 0 ? false : true;
          }
        },
        () => console.log("Something went wrong!!"),
        () => this.loadCollectionCompleted(this.dateFromFormatted, this.dateToFormatted),

      );
    }
  }


  loadCollectionCompleted(formattedDateFrom: string, formattedDateTo: string) {
    this.loadItemsMenu();

    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      "Report/getCrewChangeReport?pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
      "&sortBy=" + "&sortDir=" +
      "&language=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En") +
      "&userId=" + this.currentUser.UserId + "&userName=" + encodeURIComponent(this.userName) + "&requestNumber=" + this.requestNumber +
      "&from=" + formattedDateFrom + "&to=" + formattedDateTo + "&serviceId=" + this.serviceId +
      "&statusId=" + this.serviceStatus +
      "&directionId=" + this.directionId +
      "&transitDate=" + this.transitDateFormatted +
      "&isCompleted=" + this.isCompleted +
      "&vesselName=" + encodeURIComponent(this.unitName),
      "SHARED.REPORTS.CrewChange_OBJECT", this.itemsMenu, "", "", "");
    //Disable Loader
    this.global.isLoaderEnabled = false;

  }
  onChangepayedBothRadioButton(evt) {

    var target = evt.target;
    if (target.checked) {

    }
  }
  resetReport() {
    this.creationDateFrom = "";
    this.creationDateTo = "";
    this.dateFromFormatted = "";
    this.dateToFormatted = "";
    this.directionId = "";
    this.transitDate = "";
    this.transitDateFormatted = "";
    this.unitName = "";

    this.serviceId = "29";
    this.serviceStatus = "";
    this.userName = "";
    this.requestNumber = "";
    this.hideExportButton = false;
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.isCompleted = null;
    //this.statusesList = [];
    this.loadReport();

  }


  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
    this.itemsMenu[1].TitleAr = "تاريخ الطلب";
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = "Workflow Status";
      this.itemsMenu[2].TitleAr = "حالة مسار العمل";
    }
  }

  loadLookups() {
    this.changeService(29, true);
    //this.servicesList= ([{"Id":29,"NameEN":"Crew Change","NameAR":" تغيير الطاقم","IsDeleted":false}])

    /* this.myReportsService.getCrewChangeReportLookups().subscribe(
     response=>this.servicesList = response.Data.Services,
       () => console.log("Something went wrong!!"),
       () => console.log("Completed"));*/
  }

  loadSailDirections(): void {
    this.lookupService.getSailDirections().subscribe(
      data => this.sailDirections = data.Data as SailDirection[],
      () => console.log("Something went wrong!!"),
      () => console.log("Completed")
    );
  }
  storeSearchCriteria() {
    this.global.CrewChangeReportSearchCriteria = [];
    this.global.CrewChangeReportSearchCriteria.push({
      creationDateFrom: this.creationDateFrom,
      creationDateTo: this.creationDateTo,
      serviceId: this.serviceId,
      serviceStatus: this.serviceStatus,
      requestNumber: this.requestNumber,
      transitDate: this.transitDate,
      directionId: this.directionId,
      unitName: this.unitName,
      userName: this.userName,
      isCompleted: this.isCompleted

    });

  }
  createExportingParametersUrl() {
    this.exportngParametersUrl = "&sortBy=" + "&sortDir=" +
      "&language=" + this.lang + "&userId=" + this.currentUser.UserId + "&userName=" + encodeURIComponent(this.userName) + "&requestNumber=" + this.requestNumber + "&from=" + this.dateFromFormatted + "&to=" + this.dateToFormatted + "&serviceId=" + this.serviceId +
      "&statusId=" + this.serviceStatus + '&directionId=' + this.directionId + '&transitDate=' + this.transitDateFormatted + '&isCompleted=' + this.isCompleted + '&unitName=' + encodeURIComponent(this.unitName);

  }
  ExportExcel() {
    this.translate.get('SHARED.REPORTS.CrewChange_OBJECT_EXPORTING').subscribe((response: string) => {
      let ExportExcelUrl = AppConfig.settings.apiServer.apiUrl +
        "Report/ExportChangeCrewReportExcel?CrewChangeObject=" + JSON.stringify(response) + this.exportngParametersUrl;
      window.open(ExportExcelUrl, '_self');
    });
  }



  loadSearchCriteria() {
    if (this.global.CrewChangeReportSearchCriteria.length > 0) {

      this.creationDateFrom = this.global.CrewChangeReportSearchCriteria[0].creationDateFrom;
      this.creationDateTo = this.global.CrewChangeReportSearchCriteria[0].creationDateTo;
      this.serviceId = this.global.CrewChangeReportSearchCriteria[0].serviceId;
      this.serviceStatus = this.global.CrewChangeReportSearchCriteria[0].serviceStatus;
      this.requestNumber = this.global.CrewChangeReportSearchCriteria[0].requestNumber;
      this.transitDate = this.global.CrewChangeReportSearchCriteria[0].transitDate;
      this.directionId = this.global.CrewChangeReportSearchCriteria[0].directionId;
      this.unitName = this.global.CrewChangeReportSearchCriteria[0].unitName;

      this.userName = this.global.CrewChangeReportSearchCriteria[0].userName;
      this.changeService(29, true);
      this.global.CrewChangeReportSearchCriteria = [];

    }
  }

  changeService(serviceId, isLoadingSearchCriteria) {

    if (!serviceId) {
      this.statusesList = [];
    }
    if (!isLoadingSearchCriteria)
      this.serviceStatus = "";
    this.myRequestsService.getMyRequestsStatusesLookups(serviceId).subscribe(

      response => this.statusesList = response.Data.Statuses,
      () => console.log("Something went wrong!!"),
      () => console.log("Completed"),

    );

  }

  keyword = 'DisplayName';
  selectAgentNameEvent(item) {

    console.log(item);
    this.userName = item.DisplayName;
  }

  onAgentsNamesSearchChange(val: string) {

    this.loadAgentsDisplayNames(val);

  }

  onFocused(e) {

    // do something when input is focused
  }

  isFromDateGreaterThanToDate(): Boolean {

    var isFromDateGreaterThanToDate = false;
    if (this.creationDateTo) {
      isFromDateGreaterThanToDate = this.creationDateFrom > this.creationDateTo;
    }
    return isFromDateGreaterThanToDate;
  }

  isFromDateGreaterThanTodayDate(): Boolean {

    var isFromDateGreaterThanTodayDate = false;
    var today = new Date();
    var todayDate = this.datepipe.transform(today, 'MM/dd/yyyy');
    var selectedCreationDateFrom = this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
    isFromDateGreaterThanTodayDate = selectedCreationDateFrom > todayDate;
    return isFromDateGreaterThanTodayDate;
  }
  removeAllValidationMessages() {
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
  }

  getPendingTask(requestId) {
    this.myTasksService.getAdminTasksByRequestId(this.currentUser.UserName, requestId).subscribe(
      d => {
        if (d.Success) {
          if (d.Data.Collection.length == 0) {
            window.alert(this.translate.instant('SHARED.REPORTS.EBOOKING_REPORT.ZERO_TASKS_REQUEST_MESSAGE'));
          }
          else if (d.Data.Collection.length == 1) {
            this.router.navigate([d.Data.Collection[0]["Url"]], { state: { data: { requestId, appInstanceId: requestId } } });
          }
          else if (d.Data.Collection.length > 1) {
            window.alert(this.translate.instant('SHARED.REPORTS.EBOOKING_REPORT.MULTI_TASKS_REQUEST_MESSAGE'));
          }
          console.log(d.Data.Collection.length);
        }
      }

    );

  }
  postRequestToSCA(requestId) {
    this.global.isLoaderEnabled = true;
    this.crewChangeService.postRequestToSCA(requestId).subscribe(
      d => {
        if (d.Success) {
          this.global.isLoaderEnabled = false;
          window.alert(this.translate.instant('ADMIN_USER.CREW_CHANGE.REQUEST_POSTED_TO_SCA'));
          this.ngOnInit();
        }
        else {
          this.global.isLoaderEnabled = false;
          window.alert(d.ErrorMessages);
        }

    })
  }
}



export class MenuItem {
  Title: string;
  TitleAr: string;
};

